import { createPayloadAction, createRequestActionCreators, RequestAction } from 'helpers/actionsHelpers'
import { PayloadAction } from 'interfaces/action'
import { TimeframeTyped } from 'interfaces/global'
import { Timeframe } from 'interfaces/chart'
import { Trend } from 'interfaces/trend'
import { NetworthFilterPreferencesApiPayload, NetworthSummaryResponse, NetworthSummaryTimeframe } from 'interfaces/networth'
import { RelationId } from 'interfaces/peergroups'

export const GET_MEMBER_NETWORTH_CHANGE = 'GET_MEMBER_NETWORTH_CHANGE' as const
type GetNetworthChange = PayloadAction<typeof GET_MEMBER_NETWORTH_CHANGE, TimeframeTyped>
export const getMemberNetworthChangeActionCreator = (timeframe: Timeframe): GetNetworthChange =>
  createPayloadAction(GET_MEMBER_NETWORTH_CHANGE, { timeframe })

export const SET_MEMBER_NETWORTH_CHANGE = 'SET_MEMBER_NETWORTH_CHANGE' as const
type SetNetworthChange = PayloadAction<typeof SET_MEMBER_NETWORTH_CHANGE, TimeframeTyped & { change: Trend }>
export const setMemberNetworthChangeActionCreator = (timeframe: Timeframe, change: Trend): SetNetworthChange =>
  createPayloadAction(SET_MEMBER_NETWORTH_CHANGE, { timeframe, change })

export const GET_NETWORTH_SUMMARY = 'GET_NETWORTH_SUMMARY' as const
type GetNetworthSummary = RequestAction<typeof GET_NETWORTH_SUMMARY, NetworthFilterPreferencesApiPayload, NetworthSummaryResponse>
export const getNetworthSummaryActionCreator = createRequestActionCreators(GET_NETWORTH_SUMMARY)

export const SET_NETWORTH_SUMMARY_RELATION = 'SET_NETWORTH_SUMMARY_RELATION' as const
type SetNetworthSummaryRelation = PayloadAction<typeof SET_NETWORTH_SUMMARY_RELATION, { peergroup_relation: RelationId }>
export const setNetworthSummaryRelationActionCreator = (peergroup_relation: RelationId): SetNetworthSummaryRelation =>
  createPayloadAction(SET_NETWORTH_SUMMARY_RELATION, { peergroup_relation })

export const SET_NETWORTH_SUMMARY_TIMEFRAME = 'SET_NETWORTH_SUMMARY_TIMEFRAME' as const
type SetNetworthSummaryTimeframe = PayloadAction<typeof SET_NETWORTH_SUMMARY_TIMEFRAME, { timeframe: NetworthSummaryTimeframe }>
export const setNetworthSummaryTimeframeActionCreator = (timeframe: NetworthSummaryTimeframe): SetNetworthSummaryTimeframe =>
  createPayloadAction(SET_NETWORTH_SUMMARY_TIMEFRAME, { timeframe })

type Action =
  | GetNetworthChange
  | SetNetworthChange
  | GetNetworthSummary
  | SetNetworthSummaryRelation
  | SetNetworthSummaryTimeframe

export default Action
